"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Transactions = (props) => {
    const { width, height } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fillRule: "evenodd", fill: "none" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement(react_native_svg_1.G, { stroke: "#111" },
                react_1.default.createElement(react_native_svg_1.Path, { d: "M7 11h9M7 14h6M7 8h9" }),
                react_1.default.createElement(react_native_svg_1.Path, { d: "M15.061 18.548 11.6 20.4l-3.287-1.852L5 20.4V3h13.2v17.4z", strokeLinecap: "square" })))));
};
Transactions.defaultProps = {
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(Transactions);
